/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { useEffect, useState } from '@wordpress/element';
import {
	InnerBlocks,
	RichText,
} from '@wordpress/block-editor';
import { Icon } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';

const Edit = ( props ) => {
	const { attributes, isSelected, setAttributes, className } = props;
	const { initialOpen, blockClientId } = attributes;

	const [ { showContent }, setState ] = useState( {
		showContent: true,
	} );

	useEffect( () => {
		setState( {
			showContent: initialOpen,
		} );
	}, [] );

	const wrapperClasses = classnames(
		className,
		`gutenify-block-content-toggle-item-wrapper`,
		`gutenify-section-${ blockClientId }`,
	);

	return <div className={ wrapperClasses }>
		{ isSelected && <Inspector { ...props } /> }
		<div className="gutenify-content-toggle-item-wrapper">
			<div className="gutenify-content-toggle-item-header">
				<RichText
					// { ...props }
					tagName="h4" // The tag here is the element output and editable in the admin
					value={ attributes.title } // Any existing content, either from the database or an attribute default
					allowedFormats={ [ 'core/bold', 'core/italic' ] } // Allow the content to be made bold or italic, but do not allow other formatting options
					onChange={ ( title ) => setAttributes( { title } ) } // Store updated content as a block attribute
					placeholder={ __( 'Heading...' ) } // Display this text before any content has been added by the user
					className="gutenify-content-toggle-item-heading"
				/>
				<button onClick={ () => {
					setState( {
						showContent: ! showContent,
					} );
				} } className="gutenify-content-toggle-item-handle">
					{ showContent && <Icon icon="arrow-up-alt2" /> }
					{ ! showContent && <Icon icon="arrow-down-alt2" /> }
				</button>
			</div>
			{ showContent && <div className="gutenify-content-toggle-item-content"><InnerBlocks
				template={ [ [ 'core/paragraph', { placeholder: __( 'Enter FAQ Content or add Blocks' ) } ] ] }
				renderAppender={ false }
			/></div> }
		</div>

	</div>;
};

export default Edit;
